import { render } from "./museumActivityDetail.vue?vue&type=template&id=655a588b"
import script from "./museumActivityDetail.vue?vue&type=script&lang=js"
export * from "./museumActivityDetail.vue?vue&type=script&lang=js"

import "./museumActivityDetail.vue?vue&type=style&index=0&id=655a588b&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__